export class ForgotPassword {
  constructor (
    public email: string,
    public msg: string
  ) {}
}



// WEBPACK FOOTER //
// /Users/adminuser/Documents/pentagon/pentagon-admin/src/app/model/forgot-password.ts